import { render, staticRenderFns } from "./PageTask.vue?vue&type=template&id=03dc3475&scoped=true&"
import script from "./PageTask.vue?vue&type=script&lang=js&"
export * from "./PageTask.vue?vue&type=script&lang=js&"
import style0 from "./PageTask.vue?vue&type=style&index=0&id=03dc3475&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc3475",
  null
  
)

export default component.exports